import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Register from "./pages/Register";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import VerifyAccount from "./pages/VerifyAccount";
import ProtectedRoute from "./components/ProtectedRoute";
import CityMap from "./pages/CityMap";
import CityDetail from "./pages/CityDetail";
import DumpUpload from "./pages/DumpUpload";
import DragDropCSV from "./pages/DragDropCSV";
import CityTable from "./pages/CityTable";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
        <Route path="/verify-email/:uidb64/:token" element={<VerifyAccount />} />
        <Route path="/city-table" element={<ProtectedRoute><CityTable /></ProtectedRoute>}/>
        <Route path="/upload-dump" element={<ProtectedRoute><DumpUpload /></ProtectedRoute>} />
         <Route path="/upload-csv" element={<DragDropCSV />} />


      {/* 🔒 Protected routes */}

        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}/>
        <Route path="/cities" element={<ProtectedRoute><CityMap /></ProtectedRoute>}/>
        <Route path="/cities/:cityId" element={<ProtectedRoute><CityDetail /></ProtectedRoute>}/>

      </Routes>
    </Router>
  );
}

export default App;
